import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmeraldButtonModule } from '@emerald-angular/button';
@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
 imports: [CommonModule, EmeraldButtonModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  @Input() isOpen: boolean = false;
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() messageHtml: string = '';
  @Input() submitLabel: string = '';
 
  @Input() cancelLabel: string = '';
  /** Disables the confirm button (e.g. until a projected mandatory field is filled). */
  @Input() submitDisabled: boolean = false;
 
  @Output() confirm = new EventEmitter<void>();
 
  @Output() cancel = new EventEmitter<void>();
 
  onConfirm(): void {
    this.confirm.emit();
  }
 
  onCancel(): void {
    this.cancel.emit();
  }
}
